import React, { Component } from "react";

export default class ProjectDescription extends Component {

	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.handleToggle = this.handleToggle.bind(this)
		this.handleResize = this.handleResize.bind(this)
		this.state = {
			inView: false,
			open: false,
			maxHeight: 0,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	}  	
	
	handleToggle() {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
    
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({
		  		maxHeight : this.accordionBodyInner.clientHeight,
		  	});
  		} else {
	  		this.setState({
		  		maxHeight : 0,
		  	});
  		}
  	}
    
	render () {
		
		let post = this.props.post;
	
		if (post) {
						
		    return (
			    
			    <div className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
			    			    						
					<div className="c-project__description">
						
						<div className="c-project__description__header">
							
							<h2 className="c-project__description__content c-heading c-heading--mobile-bottom-space" dangerouslySetInnerHTML={ {__html:post.title}}></h2>
							
						</div>
						
						<div className="c-project__description__text">
							
							<div className="c-project__description__content scope-text" dangerouslySetInnerHTML={ {__html:post.description}}></div>
							
							{post.description_more &&
								
								<>
									<div className={'c-project__description__accordion ' + (this.state.open ? 'state-open' : "")}>
										<div className="c-project__description__accordion__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
											<div className="c-project__description__accordion__body__inner" ref={e => (this.accordionBodyInner = e)}>
												<div className="c-project__description__content c-project__description__content--secondary scope-text" dangerouslySetInnerHTML={{__html: post.description_more}}></div>
											</div>
										</div>
									</div>
									{this.state.open &&
										<p className="c-project__description__accordion__trigger c-paragraph c-paragraph--top-space c-paragraph--link-underline" onClick={this.handleToggle} dangerouslySetInnerHTML={{__html:'Less'}}></p>
									}
									{!this.state.open &&
										<p className="c-project__description__accordion__trigger c-paragraph c-paragraph--top-space c-paragraph--link-underline" onClick={this.handleToggle} dangerouslySetInnerHTML={{__html:'More'}}></p>
									}
								</>
							}
							
						</div>
															
					</div>
					
				</div>
									    
			)
			
		} else {
			
			return null;
		
		}
	}
}
